export default "__VITE_ASSET__BLyWM8jO__"